<template>
  <el-dialog
    :title="isImportContract ? '导入总包合同' :'上传合同扫描件'"
    :visible.sync="isShow"
    :before-close="hideAddDialog"
    width="24%"
    :close-on-click-modal="false"
    style="text-align:center"
  >
    <el-upload
      ref="upload"
      class="upload-demo"
      action="111"
      :data="uploadParam"
      :on-error="uploadFaildAction"
      :on-success="upLoadSuccessAction"
      :auto-upload="false"
      :on-change="fileChanged"
      :file-list="files"
      multiple
      drag
    >
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">
        将文件拖到此处，或
        <em>点击上传</em>
      </div>
    </el-upload>
    <div slot="footer" class="dialog-footer">
      <el-button @click="hideAddDialog">取 消</el-button>
      <el-button type="primary" @click="submitUpload">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {
  uploadContractFilesService, //上传劳务合同扫描件接口
  confirmuploadFilesService //确认上传分项合同扫描件
} from "../../../services/allContractServices";
export default {
  name: "uploadDialog",
  props: {
    isShow: {
      default: false,
      type: Boolean
    },
    isImportContract: {
      default: true,
      type: Boolean
    },
    subContractId:{
      default: "",
      type: Number
    }
  },
  data() {
    return {
      uploadUrl: "",
      uploadParam: {},
      files: [],
      fileList: new FormData(),
      importData: [] //导入返回数据
    };
  },
  methods: {
    hideAddDialog() {
      this.fileList=new FormData();
      this.$emit("close");
      this.$refs.upload.clearFiles();
    },
    fileChanged(file, fileList) {
      this.fileList.append('file', file.raw);
    },
    submitUpload() {
      this.importData=[];
      if(!this.isImportContract)   //导入合同扫描件
      {
         uploadContractFilesService(this.fileList)
        .then(data => {
          if (data.code == 10000000) {
            this.importData = data.data;
            this.importData.forEach(item=>{
              item.contractId=this.subContractId;
            })
            confirmuploadFilesService( this.importData).then(res => {
              if (res.code == 10000000) {
                this.$alert("上传成功", "提示", {
                  confirmButtonText: "确定",
                  type: "warning"
                });
                this.isShow=false;
                this.hideAddDialog();
                this.$refs.upload.clearFiles();
                // this.$emit("saveImportItems", this.importData);
              } else {
                this.$alert(res.msg, "提示", {
                  confirmButtonText: "确定",
                  type: "warning"
                });
              }
            });
          } else if (data.code >= 20000000) {
            this.$alert(data.msg, "提示", {
              confirmButtonText: "确定",
              type: "warning"
            });
          } else {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
              type: "warning"
            });
          }
        })
        .catch(error => {
          this.$alert(error, "提示", {
            confirmButtonText: "确定",
            type: "warning"
          });
        });

      }
     
    },
    upLoadSuccessAction(response, file, fileList) {
      // if (response.resultCode == 0) {
      //   this.$message.success(response.msg);
      // } else {
      //   this.$message.error(response.msg);
      // }
      this.hideAddDialog();
    },
    uploadFaildAction(err, file, fileList) {
      this.$message.error(err.msg);
    }
  }
};
</script>

<style scoped>
/deep/.el-upload-dragger {
  width: 100%;
}
</style>